import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconClockSquare: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="clock-square, time, timer"><path d="M20.25 3.75H3.75V20.25H20.25V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><circle cx="12" cy="12" r="5.25" stroke="currentColor" strokeWidth="1.5"/><path d="M12 9.75V11.9996L13.75 13.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconClockSquare;
